import { createAction } from '@reduxjs/toolkit';

import { GET_FILE_STATES, ON_FILE_STATE_CHANGED } from './actionTypes';

export const getFileStates = createAction<string>(GET_FILE_STATES.BASE);

export const onFileStateChanged = createAction(ON_FILE_STATE_CHANGED.BASE);
